export const painPoints = [
  {
    emoji: '🧭',
    title: 'You Don’t Know Where to Start',
    desc: 'A blank document, an unstructured meeting, or an unclear task can take more time than expected. You need a practical starting point for organizing information and deciding what to include.',
  },
  {
    emoji: '🔤',
    title: 'Your Communication Needs More Structure',
    desc: 'Instructions, reports, updates, and follow-up messages need to be clear and professional. Generic AI responses may not reflect your actual context or expectations.',
  },
  {
    emoji: '🧩',
    title: 'Your Daily Processes Are Inconsistent',
    desc: 'Recurring responsibilities can become difficult to manage when every report, handover, checklist, or planning session starts from scratch.',
  },
  {
    emoji: '🎯',
    title: 'You Want to Spend More Time Supervising and Less Time Rewriting',
    desc: 'Administrative work is part of the job, but unnecessary repetition can make it harder to focus on coordination, problem-solving, and supporting your team.',
  },
];
